import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseUrl, apiKey } from '../../../utils/config';

export const cancelPendingOrder = createAsyncThunk(
  'orders/cancelPendingOrder',
  async (orderData, { rejectWithValue }) => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(`${apiBaseUrl}/trade/cancel-pending-order`, {
        api_key: apiKey,
        account: orderData.account,
        order_id: orderData.order_id
      },
        {
          headers: {
            "Trade-Account-Token": token
          }
        }
      );

      // Ensure response and data exist
      if (response && response.data) {
        const res = response.data

        console.log("order-close res", res);

        return res;  // Return the API response data
      } else {
        return rejectWithValue('No response data found.');
      }
    } catch (error) {
      // Check if there's a specific error response from the server
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue('An unknown error occurred.');
      }
    }
  }
);



const cancelPendingOrderSlice = createSlice({
  name: 'cancelPendingOrder',
  initialState: {
    loading: false,
    successMessage: '',
    errorMessage: ''
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.successMessage = '';
      state.errorMessage = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(cancelPendingOrder.pending, (state) => {
        state.loading = true;
        state.successMessage = '';
        state.errorMessage = '';
      })
      .addCase(cancelPendingOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message
        //   || 'Order Cancelled successfully';  // Default success message
        state.errorMessage = '';
      })
      .addCase(cancelPendingOrder.rejected, (state, action) => {
        state.loading = false;
        state.successMessage = '';
        state.errorMessage = action.payload || 'Failed to Cancel the order';
      });
  }
});

export const { resetState } = cancelPendingOrderSlice.actions;

export default cancelPendingOrderSlice.reducer;